import { render, staticRenderFns } from "./reportesGral.vue?vue&type=template&id=e313e080&"
import script from "./reportesGral.vue?vue&type=script&lang=js&"
export * from "./reportesGral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports